module.exports = __webpack_public_path__ + "img/lisa_1x1.7b23ca73.webp";